import { render, staticRenderFns } from "./edit-letter.vue?vue&type=template&id=1bc42974&scoped=true"
import script from "./edit-letter.vue?vue&type=script&lang=js"
export * from "./edit-letter.vue?vue&type=script&lang=js"
import style0 from "./edit-letter.vue?vue&type=style&index=0&id=1bc42974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc42974",
  null
  
)

export default component.exports